export default {
  PAGE_RELOAD: 'page_reload',
  BERTH_CLIENT_ERROR: 'berth_client_error',
  DUPLICATED_SEND_CODE: 'duplicated_send_code',
  SKIP_PHONE_NUMBER_BUG: 'skip_phone_number_bug',
}
